<template>
	<main id="paxExpress" class="pax_global">
		<HeaderTab :title="$t('pax.pax_inverse')" :icon="['fal', 'horse']" />
		<div class="tabs mb-3 d-lg-none">
			<ul class="nav nav-tabs nav-justified">
				<li class="nav-item"><a class="nav-link" :class="{'active' : step < 3, }" @click="openMenu"><b><font-awesome-icon :icon="['fas', 'home']"/></b><span>{{ $t('pax.accueil') }}</span></a></li>
				<li class="nav-item"><a class="nav-link" :class="{'disabled' : step < 3, 'active': step === 3}" @click="goToStep(3)"><b>1</b><span>{{ $t('pax.juments') }}</span></a></li>
				<li class="nav-item"><a class="nav-link" :class="{'disabled' : step < 4, 'active': step === 4}" @click="goToStep(4)"><b>2</b><span>{{ $t('pax.etalons') }}</span></a></li>
				<li class="nav-item"><a class="nav-link" :class="{'disabled' : step < 5, 'active': step === 5}" @click="goToStep(5)"><b>3</b><span>{{ $t('pax.comparaison') }}</span></a></li>
			</ul>
		</div>
		
		<div id="paxReverse" class="container-fluid">
			<div class="row justify-content-center">
				<ChoixLangue v-show="step === 1" @langue_choosed="goToCountry"/>
				<ChoixCountry v-show="step === 2" @country_choosed="goToPax"/>
				<template v-if="step > 2">
					<div class="col bstallion" v-show="step === 3 || ((isLg || isXl) && step === 4)">
						<Mares :mares_selected.sync="mares_selected" :step_label.sync="step_label"></Mares>
					</div>
					<div class="col" v-show="step == 4">
						<SelectionStallion ref="stallions" :stallion_selected.sync="stallion_selected" :step_label.sync="step_label"></SelectionStallion>
						<ResultCompatibiliteHReverse v-if="stallion_selected && stallion_selected.horse_id" :stallions="mares_selected" :criteres="criteres" :step_label.sync="step_label" :stallions_comparaison.sync="mares_comparaison" :mare="stallion_selected"></ResultCompatibiliteHReverse>
					</div>
					<div class="col-12" v-if="step === 5">
						<ResultCompatibiliteVReverse :stallions="mares_comparaison" :step.sync="step" :criteres="criteres" :mare="stallion_selected" :step_label.sync="step_label" :mare_graphique.sync="mare_graphique"></ResultCompatibiliteVReverse>
					</div>
					<div class="col-12" v-if="stallion_selected && step === 6">
						<PaxGraphiqueReverse :step.sync="step" :mare="mare_graphique" :stallion="stallion_selected" :step_label.sync="step_label"></PaxGraphiqueReverse>
					</div>
				</template>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
    import Constants from 'Constants'
	import UserMixin from '@/mixins/User.js'
	import Navigation from '@/mixins/Navigation.js'
	import PaxMixin from '@/mixins/Pax.js'
	import Config from '@/mixins/Config.js'
	import Window from '@/mixins/Window.js'
	import _uniqueId from 'lodash/uniqueId'

	export default {
		name: "PaxReverse",
		mixins: [UserMixin, Navigation, PaxMixin, Config, Window],
		data () {
			return {
				mares_selected: [],
				stallion_selected: null,
				criteres: [],
				mare: {},
				force_refresh: false,
				mare_graphique: null,
				step: 1,
				step_label: "",
				mares_comparaison: [],
				steps: {'comparaison_V': 5, 'mares_selected': 4, 'stallions': 3, 'country': 2, 'pax_graphique': 6},
				skipStepWatch: false, // garde anti-boucle watcher step_label → router.push
			}
		},

		beforeRouteUpdate(to, from, next) {
			// Restaure l'étape depuis la query URL (retour/avant navigateur)
			const queryToStepLabel = {
				'etalon': 'mares_selected',
				'compare': 'comparaison_V',
				'graphique': 'pax_graphique'
			}
			const toLabel = queryToStepLabel[to.query.pax_step] || 'stallions'
			this.skipStepWatch = true
			this.step_label = toLabel
			this.step = this.steps[toLabel]
			this.$nextTick(() => { this.skipStepWatch = false })
			next()
		},
		created() {
			this.init_component()
		},
		methods: {
			async init_component() {
				document.querySelector('html').classList.remove('no_scroll')
				this.mares_selected = []
				this.stallion_selected = null
				this.criteres = []
				// au reload permet de mettre à jour les critères à l'étape pax
				this.force_refresh = _uniqueId()

				const lang = this.getConfig('lang')
				const country = this.getConfig('country')
				if(lang && country) {
					this.step = 3
				}
				else if(lang && !country) {
					this.step = 2
				}
				else {
					this.step = 1
				}

				// Si accès direct à une sous-étape sans données (ex: reload), revenir à l'étape mares
				if(this.$route.query.pax_step) {
					this.$router.replace({ name: 'paxReverse' })
				}
			},

			async goToStep(step_to_go) {
				if(step_to_go < this.step) {
					this.step_label = Object.keys(this.steps).find(key => this.steps[key] === step_to_go)
				}
			},

			goToCountry() {
				this.step = 2
			},

			goToPax() {
				this.step = 3
			},

			goToHome() {
				this.init_component()
			},

			openMenu() {
				this.$store.commit('nav/open')
			},

			async getStallionCritere() {
				// stallion_selected est null à l'init et après init_component() — le watcher peut se déclencher avec une valeur nulle
				if(!this.stallion_selected || !this.stallion_selected.horse_id) return

				const criteres = await this.getCriteres(this.lang)
				if(!criteres || criteres.length === 0) return

				// horse_criteres est déjà peuplé par l'API getStallions() (valeurs / 100)
				const horse_criteres = this.stallion_selected.horse_criteres || {}

				const criteres_horse_info = criteres
					.filter(critere => critere.criteres_lang && critere.criteres_lang[0])
					.map(critere => ({
						criteres_id: critere.criteres_id,
						criteres_max: critere.criteres_max,
						criteres_min: critere.criteres_min,
						criteres_red: critere.criteres_red,
						criteres_green: critere.criteres_green,
						criteres_lang: critere.criteres_lang,
						critereslang_label: critere.criteres_lang[0].critereslang_label,
						critereslang_moins: critere.criteres_lang[0].critereslang_moins,
						critereslang_plus: critere.criteres_lang[0].critereslang_plus,
						critereslang_description: critere.criteres_lang[0].critereslang_description,
						slider: horse_criteres[critere.criteres_id] !== undefined ? horse_criteres[critere.criteres_id] : 0
					}))

				this.criteres = criteres_horse_info
			}
		},
		computed: {
			lang() {
				return this.getConfig('lang') ?? false
			},
			country() {
				return this.getConfig('country') ?? false
			},
		},
		watch: {
			step_label(val) {
				if(this.skipStepWatch) return

				const stepLabelToQuery = {
					'mares_selected': 'etalon',
					'comparaison_V': 'compare',
					'pax_graphique': 'graphique'
				}

				const query = stepLabelToQuery[val]
				if(query) {
					this.$router.push({ name: 'paxReverse', query: { pax_step: query } })
				} else {
					this.step = this.steps[val]
					if(this.$route.query.pax_step) {
						this.$router.replace({ name: 'paxReverse' })
					}
				}
			},
			stallion_selected(val) {
				this.getStallionCritere()
			}
		},
		components: {
			HeaderTab: () => import('@/components/HeaderTab'),
			SelectionStallion : () => import('@/components/Pax/SelectionStallion'),
			Mares : () => import('@/components/Pax/Mares'),
			ResultCompatibiliteHReverse : () => import('@/components/Pax/ResultCompatibiliteHReverse'),
			ResultCompatibiliteVReverse : () => import('@/components/Pax/ResultCompatibiliteVReverse'),
			ChoixLangue: () => import('@/components/Pax/ChoixLangue'),
			ChoixCountry: () => import('@/components/Pax/ChoixCountry'),
			PaxGraphiqueReverse : () => import('@/components/Pax/PaxGraphiqueReverse')
		}
	};
</script>
